module.exports = __webpack_public_path__ + "img/interreg.a3cbf3ea.png";